(ns ycweb.app.website.registry.search
  (:require
   [cemerick.url :as url]
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn registry-search-card [app-atom registry]
  (let [{:registry/keys [public-id title close-date]} registry]
    [:div
     {:key (:ent/uuid registry)
      :class (yuc/bem :flex-grid-block [:l-1-4 :ml-1-3 :t-1-2])}
     [:article.registry-card.card.flex-grid-content
      [:a.block-link.group
       (urlstate/href-props app-atom "registry" "view" {:uuid (:ent/uuid registry)})
       [:div.registry-card__hero
        [:div.u-block-center.u-max-width-80
         (web-common/lazy-image app-atom
           (or (yuc/presence public-id) "registries/default/registry_avatar_140_140")
           {:class [:avatar (yuc/bem :yc-simple-image [:full])]}
           {:w 80 :h 80 :alt title})]]
       [:div.registry-card__content
        [:div.registry-card__title-wrapper
         [:h2.registry-card__title title]]
        [:p.registry-card__description
         "Getting married on"
         [:span.u-hidden-from-view " "]
         [:span.registry-card__date (ud/date-format (ud/coerce-date close-date) "dd MMM YYYY")]]]
       [:div.registry-card__footer
        [:span
         {:class (yuc/bem :button [:bordered :secondary :small :raised])}
         [:span.button__text "View registry"]]]]]]))

(defn show-results [app-atom registries]
  [:div {:class (yuc/bem :flex-grid-group [:align-left])}
   (map (partial registry-search-card app-atom) registries)])

(defn registry-no-search-results [app-atom search-term]
  [:div
   {:class (yuc/bem :yc-section [:standard])}
   (headings/heading
     (str "No search results for \"" (yuc/capitalize-words search-term) "\"")
     {:type :h1 :size :medium :center true})
   [:div.u-max-width-640.u-block-center
    [:p.yc-paragraph.u-text-center
     "We can't seem to find a registry with those details. "
     [:a.text-link
      (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/find-registry-modal {}))
      "Try searching again"]
     " or give us a call on 0861 702 4969 and we'll help you out."]]
   [:div.u-block-center.u-text-center
    (buttons/button-web
      "Search Again"
      {:on-click #(grid/dispatch-action app-atom :web.registry/find-registry-modal {})
       :style :primary})]])

(defn key-listener [app-atom e]
  (let [search-atom (rum/cursor-in app-atom [:registry :search])]
    #?(:cljs
       (cond
         (= (.-keyCode e) 13); enter key
         (do
           (.preventDefault e)
           (grid/dispatch-action app-atom :web.registry/search @search-atom))))))

(defn setup-keys [app-atom]
  #?(:cljs
     (.setTimeout js/window
       (fn [e]
         (let [button (.getElementById js/document "registry-search")]
           (.addEventListener button "keydown" #(key-listener app-atom %))))
       30)))

(defmethod grid/action :web.registry/find-registry-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/find-registry-modal
    {:config
     {:title "Find Registry"}})
  (setup-keys app-atom))

(rum/defc registry-search < rum/reactive [app-atom]
  (let [searching? (cmn/curact (cmn/process-cursor app-atom) :searching?)
        search-term (cmn/curact (cmn/process-cursor app-atom) :search-term)
        registries (cmn/curact (cmn/process-cursor app-atom) :registries)]
    [:div
     {:class (yuc/bem :yc-page-content [:standard])}
     (cond
       (not (empty? registries))
       [:div
        {:class (yuc/bem :yc-section [:standard])}
        (headings/heading
          (str (if registries "Search results for " "No search results for ") (yuc/capitalize-words search-term))
          {:type :h1
           :size :medium})
        (show-results app-atom registries)]

       (and (empty? registries) (not searching?))
       (registry-no-search-results app-atom search-term))

     (when
       (and (not (empty? registries)) (not searching?))
       [:aside
        {:class (yuc/bem :yc-section [:large])}
        [:div.u-max-width-480.u-block-center.u-text-center
         [:p.yc-paragraph "Can't find the couple you're looking for?"]
         (buttons/button-web "Search Again"
           {:type :button
            :on-click #(grid/dispatch-action app-atom :web.registry/find-registry-modal {})
            :style :primary
            :size :default})]])
     (toaster/loading-overlay app-atom :web.registry/search)]))

(defmethod flow/render-screen :web.registry/search [app-atom _]
  (website/screen-wrapper app-atom
    (registry-search app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/search [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/search)
  (swap! (cmn/process-cursor app-atom) assoc
    :searching? true)
  (comms/ajax-get :web.registry/search (select-keys params [:first-name :last-name])))

(defmethod grid/action :web.registry/search [app-atom {:keys [first-name last-name] :as config} _]
  (let [first-name (url/url-encode first-name)
        last-name (url/url-encode last-name)]
    (toaster/open-toast app-atom :processing "Searching registries" {:closetime 10000})
    (comms/ajax-get :web.registry/search
      {:first-name first-name
       :last-name last-name})))

(defmethod comms/receive :web.registry/search
  [app-atom {:keys [search-term registries params]}]
  (toaster/close-toast app-atom)
  (grid/close-modal app-atom)
  #_(scroll/scroll-to-top)
  (swap! (cmn/process-cursor app-atom) assoc
    :searching? false
    :search-term search-term
    :registries registries)
  (urlstate/navigate app-atom nil (urlstate/url "/registry.htm" (merge {:action "search"} params)))
  (toaster/close-overlay app-atom :web.registry/search))